import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import {AppDataService} from "../../../../services/app-data.service";
import { CompanyService }  from '../../../../services/company.service';
import { TranslationService } from '../../../../services/translation.service';
declare let $: any;
declare let Swal: any;

@Component({
    selector : 'calendar-screen',
    templateUrl:'calendar-screen.html'
})
export class CalendarScreenComponent implements OnInit, OnDestroy{

  public admin=false;
  public list;
  public constructor( private _router : Router,public translate: TranslationService,public _appData : AppDataService,private _companyService : CompanyService) {
  }
  public ngOnInit(): any {
    this.list=[];
    this._companyService.getCalendar(this._appData.instagramUser.uid).get().then(snap=>{
      snap.forEach( rSnap =>{
        let room=rSnap.data();
        let dt=this.longToDate(room.start)
        room.startDate=dt;
        this.list.push(room)
      })
    })

  }
  public ngOnDestroy() : any {
  }
  public longToDate(number){
    let date=new Date(number)
    let day=date.getDate();
    let month=date.getMonth()+1;
    let monthStr=month.toString();
    if (monthStr.length==1) monthStr='0'+monthStr;
    let year=date.getFullYear();
    let hour=date.getHours();
    let hourStr=hour.toString();
    if (hourStr.length==1) hourStr='0'+hourStr;
    let minute=date.getMinutes()
    let minuteStr=minute.toString();
    if (minuteStr.length==1) minuteStr='0'+minuteStr;

    return day+'/'+monthStr+'/'+year+' '+hourStr+':'+minuteStr
}

  public goto(roomToGo){
    let room=this._appData.room;
    
    if (room.id==roomToGo.id){
      Swal.fire({title:this.translate.instant('FAVORITE_ROOM_SCREEN_8'),text:this.translate.instant('FAVORITE_ROOM_SCREEN_9')})
    }
    else{
      
      Swal.fire({
        title:this.translate.instant('CONTACT_SCREEN_COMPONENT_14'),
        text:this.translate.instant('FAVORITE_ROOM_SCREEN_10'),
        confirmButtonText: this.translate.instant('YES'),
        cancelButtonText:this.translate.instant('NO'),
        showCancelButton: true,     
        showCloseButton: true,
      }).then((result) => {
        if (result.value) {
          this.gotoRoom(roomToGo);
        }
      });       
    }
  }
  public delete(room){
    Swal.fire({
      title:'Deletar',
      text:'Você deseja deletar esse agendamento?',
      confirmButtonText: this.translate.instant('YES'),
      cancelButtonText:this.translate.instant('NO'),
      showCancelButton: true,     
      showCloseButton: true,
    }).then((result) => {
      if (result.value) {
        this._companyService.getCalendar(this._appData.instagramUser.uid).doc(room.id).delete();

        for (let i=0;i<this.list.length;i++){
          if (this.list[i].id==room.id){
            this.list.splice(i,1)
          }
        }
      }
    });       

  }
  public gotoRoom(room){
    let roomToGo=room.id
              let domain=window.location.origin
              window.location.href=domain+"/speakerroom/"+this._appData.event.id+'?evt='+room.father+'&speaker='+room.id;
  }
  public seeProfile(room){
  }
}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/cellphone-modal/calendar/calendar-screen.ts